/** Calendar day key used by report date filters: yyyy-MM-dd in local time. */
export function formatLocalDate(value: Date): string {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, '0');
  const day = String(value.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/** Turns an API date value into yyyy-MM-dd. Display labels that are not dates return ''. */
export function toDateKey(value: unknown): string {
  if (value == null || value === '') {
    return '';
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? '' : formatLocalDate(value);
  }
  const text = String(value).trim();
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(text);
  if (iso) {
    return `${iso[1]}-${iso[2]}-${iso[3]}`;
  }
  const dayFirst = /^(\d{2})[\/\-](\d{2})[\/\-](\d{4})/.exec(text);
  if (dayFirst) {
    return `${dayFirst[3]}-${dayFirst[2]}-${dayFirst[1]}`;
  }
  return '';
}

/**
 * Dates the calendar may select. `dateKey` is the property the dropdown used to submit
 * (BuyingPurchaseDate, key, DispatchDate, and so on). `key` is only a fallback.
 */
export function collectEnabledDateKeys(rows: unknown, dateKey?: string): Set<string> {
  const keys = new Set<string>();
  if (!Array.isArray(rows)) {
    return keys;
  }
  const names = dateKey
    ? [dateKey, dateKey.charAt(0).toLowerCase() + dateKey.slice(1), 'key']
    : ['key'];

  for (const row of rows) {
    if (row == null) {
      continue;
    }
    if (typeof row !== 'object') {
      const key = toDateKey(row);
      if (key) {
        keys.add(key);
      }
      continue;
    }
    const record = row as Record<string, unknown>;
    for (const name of names) {
      const key = toDateKey(record[name]);
      if (key) {
        keys.add(key);
        break;
      }
    }
  }
  return keys;
}

export function cropYearNumber(value: unknown): number | null {
  const year = Number(value);
  if (!Number.isInteger(year) || year < 2000 || year > 2100) {
    return null;
  }
  return year;
}
